import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SampleDialogComponent } from 'src/app/digigov/dg_components_test/dg-dynamic-grid-test/dg-dynamic-grid-test.component';
import { ToastrService } from 'ngx-toastr';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { AppgenAuditService } from '../service/app-gen-audit.service';

@Component({
  selector: 'app-table-config-dialog',
  templateUrl: './table-config-dialog.component.html',
  styleUrls: ['./table-config-dialog.component.scss'],
})
export class TableConfigDialogComponent implements OnInit {
  tableConfigForm: any;
  oldData;

  tablen: any;
  sequencen: any;
  whereClauseN: any;

  tableList: any;
  tempTableConfiguration: any = [];

  cols: any;
  rows: any = [];

  activeUpdateIndex: any;
  isUpdate: boolean = false;
  alreadyExeSeqExists: boolean = false;

  operationList: any[] = [
    { optionValue: 1, optionText: 'Insert/Update' },
    { optionValue: 2, optionText: 'Update Only' },
  ];

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private msgDsplyService: MessageDisplayService,
    private auditService: AppgenAuditService,
    public dialogRef: MatDialogRef<TableConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.oldData = JSON.stringify(this.data);
    this.tableConfigForm = this.fb.group({
      table: [null, Validators.compose([Validators.required])],
      sequence: [null, Validators.compose([Validators.required])],
      whereClause: [null],
      operation: [null, Validators.compose([Validators.required])],
    });

    this.cols = [
      {
        columnId: 'tblId',
        columnName: 'Table Id',
        displayable: false,
      },
      {
        columnId: 'table',
        columnName: 'Table',
        displayable: true,
      },
      {
        columnId: 'tblOrder',
        columnName: 'Sequence',
        displayable: true,
      },

      {
        columnId: 'conditionClause',
        columnName: 'Where Clause',
        displayable: true,
      },
      {
        columnId: 'operationText',
        columnName: 'Operation',
        displayable: true,
      },

      {
        columnName: 'Actions',
        columnId: 'actions',
        width: 110,
        type: null,
        icons: true,
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        displayable: true,
        actionConfig: [
          {
            actionName: 'edit',
            actionIcon: 'edit',
            isVisible: true,
            isDisabled: false,
          },
          {
            actionName: 'delete',
            actionIcon: 'delete',
            isVisible: true,
            isDisabled: false,
          },
        ],
      },
    ];

    const body = {
      ComboId: '13',
    };

    this.http.post('/worklist/get-combo-list', body).subscribe(
      (res) => {
        const restemp: any = res;
        this.tableList = restemp.data;
        console.log('table--', this.tableList);

        if (this.data.jsonData != null) {
          console.log('table list---', this.tableList);
          if (
            this.data.jsonData.tableConfiguration != null &&
            this.data.jsonData.tableConfiguration.length != 0
          ) {
            this.getKeys(this.data.jsonData?.tableConfiguration).forEach(
              (table) => {
                let tableId = this.data.jsonData?.tableConfiguration[table]
                  .tblId;
                let result = this.tableList.find(
                  (o) => o.optionValue === tableId.toString()
                );

                console.log('result--', result);
                Object.assign(this.data.jsonData?.tableConfiguration[table], {
                  table: result.optionText,
                });
              }
            );

            this.rows = this.data.jsonData.tableConfiguration
              ? this.data.jsonData.tableConfiguration
              : [];
            this.rows.sort((a, b) => {
              return a.tblOrder - b.tblOrder;
            });
          }
        }
      },
      (err) => {
        console.error('Error in table', err);
      }
    );

    console.log('in table config', this.data);
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formDesigner(jsonObject: any, tableId: any) {
    let tempArray;

    this.getKeys(jsonObject).forEach((attributes, index) => {
      if (Array.isArray(jsonObject[attributes])) {
        this.formDesigner(jsonObject[attributes], tableId);
      }
      if (!Array.isArray(jsonObject[attributes])) {
        if (jsonObject[attributes].fieldColumnConfig) {
          let fieldColumnConfig = jsonObject[attributes].fieldColumnConfig;
          if (fieldColumnConfig != null && fieldColumnConfig.length != 0) {
            this.getKeys(fieldColumnConfig).forEach((fieldId, index) => {
              if (fieldColumnConfig[fieldId].tableId == tableId) {
                fieldColumnConfig[fieldId].activeFlag = 0;
              }
            });
          }
        }
      }
      if (Array.isArray(jsonObject[attributes].components)) {
        this.formDesigner(jsonObject[attributes].components, tableId);
      }
    });

    return jsonObject;
  }
  onSave() {
    if (this.rows.length == 0) {
      this.msgDsplyService.errorToast({
        errors: [
          {
            message: 'Please add at list single table',
          },
        ],
      });
    } else {
      this.getKeys(this.tempTableConfiguration).forEach((attributes, index) => {
        this.formDesigner(
          this.data.jsonData.componetDetails,
          this.tempTableConfiguration[attributes].tblId
        );
      });
      if (this.tempTableConfiguration.length != 0) {
        this.rows.push(...this.tempTableConfiguration);
      }
      // this.rows.forEach((obj) => {
      //   obj.operation = this.operationList.find(
      //     (x) => x.optionText == obj.operation
      //   ).optionValue;
      // });
      let dataToSend = {
        tableConfiguration: this.rows,
        langId: 1,
        audit: [],
      };

      this.msgDsplyService.successToast({
        messages: ['Table configuration save successfully'],
      });
      // AUDIT
      let rawOldData = JSON.parse(this.oldData);
      let oldTable = rawOldData.jsonData.tableConfiguration;
      let newTable = [...this.rows];
      let audit = this.auditService.TableConfigAudit(
        JSON.stringify(newTable),
        JSON.stringify(oldTable)
      );
      dataToSend.audit.push(audit);
      this.dialogRef.close(dataToSend);

      // this.onSaveEmit.emit(dataToSend);
      console.log('data send', dataToSend);
    }
  }

  onAdd() {
    this.alreadyExeSeqExists = false;
    let tableJson = this.tableList.find(
      (o) => o.optionValue === this.tablen.toString()
    );
    let rowj = {
      tblId: tableJson.optionValue,
      table: tableJson.optionText,
      tblOrder: this.sequencen,
      conditionClause: this.whereClauseN,
      operation: this.tableConfigForm.controls['operation']?.value?.optionValue,
      operationText: this.tableConfigForm.controls['operation']?.value
        ?.optionText,
    };

    if (this.rows.length >= this.sequencen) {
      let resSequIndex = this.sequencen - 1;

      this.alreadyExeSeqExists = true;

      const dialogRef = this.dialog.open(SampleDialogComponent, {
        width: '250px',
        data: {
          message: 'Table already exists, Do you want to replace it?',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('The dialog was closed: ', result);

        if (result) {
          this.rows.splice(resSequIndex, 0, rowj);
          for (var i = resSequIndex + 1; i < this.rows.length; i++) {
            this.rows[i] = {
              ...this.rows[i],
              tblOrder: Number(this.rows[i].tblOrder) + 1,
            };
          }
        }
        this.updateRows();

        this.msgDsplyService.successToast({
          messages: ['Row Added successfully'],
        });
      });
    }

    if (!this.alreadyExeSeqExists) {
      if (this.sequencen > this.rows.length + 1) {
        const dialogRef = this.dialog.open(SampleDialogComponent, {
          width: '250px',
          data: {
            message: 'Execution Sequence greater than the existing length',
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            return;
          }
        });
      } else {
        this.rows.push(rowj);

        this.msgDsplyService.successToast({
          messages: ['Row Added successfully'],
        });
        this.updateRows();
      }
    }
    this.tableConfigForm.reset();
    this.tableConfigForm.markAsPristine();
    this.tableConfigForm.markAsUntouched();
    this.tableConfigForm.updateValueAndValidity();
    this.tableConfigForm.get('table').clearValidators();
    this.tableConfigForm.get('table').updateValueAndValidity();
    this.tableConfigForm.get('sequence').clearValidators();
    this.tableConfigForm.get('sequence').updateValueAndValidity();
    // this.sequencen = '';
    //  this.tablen = -1;
  }

  onUpdate() {
    this.alreadyExeSeqExists = false;
    let tableJson = this.tableList.find((o) => o.optionValue === this.tablen);

    if (
      this.rows.length >= this.sequencen &&
      this.sequencen - 1 != this.activeUpdateIndex
    ) {
      let resSequIndex = this.sequencen - 1;
      this.alreadyExeSeqExists = true;
      let updatedSequence = this.sequencen;

      const dialogRef = this.dialog.open(SampleDialogComponent, {
        width: '250px',
        data: {
          message: 'Table with sequence already exists, Do you want shift it?',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('The dialog was closed: ', result);

        if (result) {
          var updateEle = this.rows[this.activeUpdateIndex];
          this.rows.splice(this.activeUpdateIndex, 1);

          this.rows.splice(resSequIndex, 0, {
            ...updateEle,
            tblId: tableJson.optionValue,
            table: tableJson.optionText,
            tblOrder: updatedSequence,
            operation: this.tableConfigForm.controls['operation']?.value
              .optionValue,
            operationText: this.tableConfigForm.controls['operation']?.value
              .optionText,
          });
          if (resSequIndex < this.activeUpdateIndex) {
            for (var i = resSequIndex + 1; i <= this.activeUpdateIndex; i++) {
              this.rows[i] = {
                ...this.rows[i],
                tblOrder: Number(this.rows[i].tblOrder) + 1,
              };
            }
          } else if (resSequIndex > this.activeUpdateIndex) {
            // let j= index-1;

            for (let i = resSequIndex - 1; i >= this.activeUpdateIndex; i--) {
              this.rows[i] = {
                ...this.rows[i],
                tblOrder: Number(this.rows[i].tblOrder) - 1,
              };
            }
          }
          this.updateRows();
        }
      });
    }

    this.updateRows();

    if (!this.alreadyExeSeqExists) {
      if (this.sequencen > this.rows.length) {
        const dialogRef = this.dialog.open(SampleDialogComponent, {
          width: '250px',
          data: {
            message: 'Execution Sequence greater than the existing length',
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            return;
          }
        });
      } else {
        // this.rows.push(rowj);
        this.rows[this.activeUpdateIndex] = {
          ...this.rows[this.activeUpdateIndex],
          tblId: tableJson.optionValue,
          table: tableJson.optionText,
          tblOrder: this.sequencen,
          conditionClause: this.whereClauseN,
          operation: this.tableConfigForm.controls['operation']?.value
            .optionValue,
          operationText: this.tableConfigForm.controls['operation']?.value
            .optionText,
        };
        this.updateRows();

        this.msgDsplyService.successToast({
          messages: ['Row Updated successfully'],
        });
      }
    }
    this.tableConfigForm.reset();
    this.tableConfigForm.markAsPristine();
    this.tableConfigForm.markAsUntouched();
    this.tableConfigForm.updateValueAndValidity();
    this.tableConfigForm.get('table').clearValidators();
    this.tableConfigForm.get('table').updateValueAndValidity();
    this.tableConfigForm.get('sequence').clearValidators();
    this.tableConfigForm.get('sequence').updateValueAndValidity();
    //  this.sequencen = '';
    // this.tablen = '';
    this.isUpdate = false;
  }
  onActionPerformed({ rowIndex, row, action, data, notifier }) {
    console.log('row--', row);
    console.log('action--', action);
    console.log('data--', data);
    console.log('notifier--', notifier);
    console.log('rowIndex--', rowIndex);

    switch (action) {
      case 'delete':
        const dialogRef = this.dialog.open(SampleDialogComponent, {
          width: '250px',
          data: { message: 'Do you want to delete?' },
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log('The dialog was closed: ', result);
          console.log('row delete', row);
          if (result) {
            if (this.rows[rowIndex].formTblMpgId != null) {
              this.rows[rowIndex].activeFlag = 0;
              this.tempTableConfiguration.push(this.rows[rowIndex]);
            }

            for (var i = rowIndex + 1; i < this.rows.length; i++) {
              this.rows[i] = {
                ...this.rows[i],
                tblOrder: Number(this.rows[i].tblOrder) - 1,
              };
            }

            this.rows.splice(rowIndex, 1);

            this.rows = [...this.rows];
            console.log(`${action} successful`);
            this.updateRows();

            this.msgDsplyService.successToast({
              messages: ['Row Deleted successfully'],
            });
          }
        });

        break;
      case 'edit':
        this.activeUpdateIndex = rowIndex;
        this.isUpdate = true;
        console.log('in edit ', row);
        //this.selectedRole=row.userRole;
        this.sequencen = row.tblOrder;
        this.tablen = row.tblId.toString();
        this.whereClauseN = row.conditionClause;
        this.tableConfigForm.controls['operation'].setValue(
          this.operationList.find((o) => o.optionText == row.operationText)
        );
        // let selTableJ = {
        //   optionText: row.tblId,
        //   optionValue: row.table,
        // };
        // this.tablen.push(selTableJ);

        break;
    }
  }
  updateRows = () => {
    if (this.rows?.toString()) this.rows = [...this.rows];
  };
  onReset() {
    this.tableConfigForm.reset();
    this.tableConfigForm.markAsPristine();
    this.tableConfigForm.markAsUntouched();
    this.tableConfigForm.updateValueAndValidity();
    this.tableConfigForm.get('table').clearValidators();
    this.tableConfigForm.get('table').updateValueAndValidity();
    this.tableConfigForm.get('sequence').clearValidators();
    this.tableConfigForm.get('sequence').updateValueAndValidity();
  }
}
